import { render, staticRenderFns } from "./InsurancePerson.vue?vue&type=template&id=5f78f73b&scoped=true&"
import script from "./InsurancePerson.vue?vue&type=script&lang=js&"
export * from "./InsurancePerson.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePerson.vue?vue&type=style&index=0&id=5f78f73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78f73b",
  null
  
)

export default component.exports